const CHECK_KEY = 'localStorageCheck';
const STATE_KEY = 'app-state';

export const isLocalStorageAvailable = () => {
  if (typeof localStorage !== 'object') {
    return false;
  }

  try {
    const value = 'check';
    localStorage.setItem(CHECK_KEY, value);
    const result = localStorage.getItem(CHECK_KEY);
    localStorage.removeItem(CHECK_KEY);
    return result === value;
  } catch (e) {
    return false;
  }
};

export const persistAppState = (state) => localStorage.setItem(STATE_KEY, JSON.stringify(state));
export const getPersistedAppState = () => JSON.parse(localStorage.getItem(STATE_KEY)) || {};
